import React, { Component } from "react";

import Models from "../components/Models";
import Logo from "../components/Logo";
import CarImage from "../components/CarImage";
import CarInfo from "../components/CarInfo";

import { objectToIndexedArray } from "../utils/Utils";

import { withRouter } from "../utils/withRouter";
import ContactForm from "../components/ContactForm";
import Modal from "../components/Modal";
import Liising from "../components/Liising";

const apiUrl = "https://laoautod.porsche.ee/back/api.php";
const pdfUrl = "https://laoautod.porsche.ee/back/print.php";
class Main extends Component {
  constructor(props) {
    super(props);
    this.state = {
      models: [],
      loading: false,
      error: null,
      currentCar: null,
      prevCar: null,
      formIsOpen: false,
      showContactModal: false,
      showSuccessModal: false,
      showLiisinModal: false,
      filteredModels: {},
      activeModel: null,
      showModelsDrawer: false,
    };

    // Bind methods
    this.fetchModels = this.fetchModels.bind(this);
  }

  async fetchModels() {
    //console.log("fetchingModels ?? ");
    try {
      this.setState({ loading: true, error: null });
      const response = await fetch(apiUrl);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      this.setState({ models: data, filteredModels: data });
      this.noKomnrAssigned(data);
    } catch (error) {
      console.error("Error fetching models:", error);
      this.setState({ error: error.message });
    } finally {
      this.setState({ loading: false });
    }
  }

  componentDidMount() {
    this.fetchModels();
    this.setState({
      currentCar: this.props.router.params.komnr,
      filteredArray: this.state.models,
    });
  }

  noKomnrAssigned(data) {
    if (data && !this.props.router.params.komnr) {
      this.props.router.navigate(`/${Object.keys(data)[0]}`);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // Handle route parameter changes
    if (prevProps.router.params.komnr !== this.props.router.params.komnr) {
      // this.fetchModels();
    }
    if (prevState.prevCar !== this.state.prevCar) {
      // this.fetchModels();
    }
  }

  getItemIndex = (itemKomnr) => {
    return Object.keys(this.state.models).findIndex(
      (item) => item === itemKomnr,
    );
  };

  getItemById = (itemKomnr) => {
    return (
      Object.keys(this.state.models).find((item) => item === itemKomnr) ||
      Object.keys(this.state.models)[0]
    );
  };

  getNextItem = (currentItemId) => {
    const currentIndex = this.getItemIndex(currentItemId);
    const nextIndex =
      (currentIndex + 1) % Object.keys(this.state.models).length;
    //return Object.keys(this.state.models)[nextIndex];

    this.setState({
      prevCar: this.state.currentCar,
      currentCar: Object.keys(this.state.models)[nextIndex],
    });
    this.props.router.navigate(`/${Object.keys(this.state.models)[nextIndex]}`);
  };

  getPrevItem = (currentItemId) => {
    const currentIndex = this.getItemIndex(currentItemId);
    const prevItemIndex =
      (currentIndex - 1 + Object.keys(this.state.models).length) %
      Object.keys(this.state.models).length;
    this.setState({
      prevCar: this.state.currentCar,
      currentCar: Object.keys(this.state.models)[prevItemIndex],
    });
    this.props.router.navigate(
      `/${Object.keys(this.state.models)[prevItemIndex]}`,
    );
    //return Object.keys(this.state.models)[prevItemIndex];
  };

  openContactModal = () => {
    this.setState({ showContactModal: true });
  };

  closeContactModal = () => {
    this.setState({ showContactModal: false });
  };

  handleFormSubmit = (formData) => {
    // Handle form submission
    this.closeContactModal();
    this.setState({ showSuccessModal: true });
  };

  closeSuccessModal = () => {
    this.setState({ showSuccessModal: false });
  };

  modelSelected2(modelName) {
    const filtered = Object.keys(this.state.models).filter(
      (product) => this.state.models[product].model === modelName,
    );
  }

  modelSelected = (modelName) => {
    const { filteredModels } = this.state;
    const filtered = Object.keys(filteredModels)
      // .filter((key) => filteredModels[key].model === modelName)
      .filter((key) => filteredModels[key].model.includes(modelName))
      .reduce((acc, key) => {
        acc[key] = {
          ...filteredModels[key],
          _originalKey: key,
        };
        return acc;
      }, {});

    this.setState(
      {
        models: filtered,
        activeModel: modelName,
        showModelsDrawer: false,
      },
      () => this.changeToAvailibleKomnr(),
    );
  };

  changeToAvailibleKomnr() {
    if (
      Object.keys(this.state.models).includes(this.props.router.params.komnr)
    ) {
    } else {
      this.props.router.navigate(`/${Object.keys(this.state.models)[0]}`);
    }
  }

  searchModels = (searchTerm) => {
    const { models } = this.state;

    const filtered = Object.keys(models)
      .filter(
        (key) =>
          models[key].model.toLowerCase().includes(searchTerm.toLowerCase()) ||
          models[key].name.toLowerCase().includes(searchTerm.toLowerCase()),
      )
      .reduce((acc, key) => {
        acc[key] = {
          ...models[key],
          _originalKey: key,
        };
        return acc;
      }, {});

    this.setState({
      filteredModels: filtered,
      searchTerm,
    });
  };

  showAll = () => {
    const { models } = this.state;
    const allWithKeys = Object.keys(models).reduce((acc, key) => {
      acc[key] = {
        ...models[key],
        _originalKey: key,
      };
      return acc;
    }, {});

    this.setState({
      filteredModels: allWithKeys,
      searchTerm: "",
    });
  };

  openModalLiising = (komnr) => {
    this.setState({ showLiisingModal: true, liisingkomnr: komnr });
  };
  closeLiisingModal = () => {
    this.setState({ showLiisingModal: false });
  };

  showModelsDrawer = () => {
    this.setState((prevState) => ({
      showModelsDrawer: !prevState.showModelsDrawer,
    }));
  };

  render() {
    const { models } = this.props;
    const { loading, error } = this.state;
    const arrayLength = Object.keys(this.state.models).length;

    const indexedArray = objectToIndexedArray(this.state.models);
    //console.log(indexedArray);
    if (loading) {
      return null; // Or return <div></div> for an empty div
    }

    if (error) {
      return <div>Error: {error}</div>;
    }
    return (
      <>
        <header className="App-header">
          <Logo />
        </header>
        <main>
          <section className="images">
            <button
              className="button button-prev"
              onClick={() => this.getPrevItem(this.props.router.params.komnr)}
            >
              &lsaquo;
            </button>
            {arrayLength > 0 &&
              this.props.router.params.komnr &&
              this.state.models[this.props.router.params.komnr] && (
                <CarImage
                  prevCarImage={this.state.models[this.state.prevCar]}
                  data={this.state.models[this.props.router.params.komnr]}
                />
              )}
            <button
              className="button button-next"
              onClick={() => this.getNextItem(this.props.router.params.komnr)}
            >
              &rsaquo;
            </button>
          </section>
          <section className="information">
            {arrayLength > 0 &&
              this.props.router.params.komnr &&
              this.state.models[this.props.router.params.komnr] && (
                <CarInfo
                  openModalLiising={this.openModalLiising}
                  data={this.state.models[this.props.router.params.komnr]}
                />
              )}
            <div className="buttons">
              <button onClick={() => this.openContactModal()}>
                SAADA PÄRING ESINDUSSE
              </button>
              <a
                className="button"
                href={`${pdfUrl}?komnr=${this.props.router.params.komnr}`}
                target="_blank"
                rel="noreferrer"
              >
                PRINDI PAKKUMINE
              </a>
            </div>
          </section>
        </main>
        {this.state.showContactModal && (
          <Modal
            isOpen={this.state.showContactModal}
            onClose={this.closeContactModal}
            title="Contact Us"
          >
            <ContactForm
              komnr={this.props.router.params.komnr}
              data={this.state.models[this.props.router.params.komnr]}
            />
          </Modal>
        )}
        {this.state.showLiisingModal && (
          <Modal
            isOpen={this.state.showLiisingModal}
            onClose={this.closeLiisingModal}
          >
            <Liising
              dataFull={this.state.models}
              data={this.state.models[this.props.router.params.komnr]}
            />
          </Modal>
        )}
        <footer
          className={
            this.state.showModelsDrawer ? "show-models" : "hide-models"
          }
        >
          <div className="modelsHeadline" onClick={this.showModelsDrawer}>
            <span>Vali mudel</span>
          </div>
          {this.state.models && (
            <Models
              activeModel={this.state.activeModel}
              modelSelected={(e) => this.modelSelected(e)}
              models={models}
              modelsapi={this.state.models}
            />
          )}
        </footer>
      </>
    );
  }
}

export default withRouter(Main);
